import Vue from "vue";
import {extend, localize, ValidationObserver, ValidationProvider} from "vee-validate";
import {confirmed, email, max, min, numeric, required, max_value, min_value} from "vee-validate/dist/rules";
import viVeeValidate from "../locale/vee-validate/vi.json";
import enVeeValidate from "../locale/vee-validate/en.json";
import {getFileExtension, getLang} from "@/helpers/helpers";

Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)

const veeValidatePlugin = {
    register() {
        console.log("Registering vee-validate service...")
        // const locale = store.getters["app/locale"];
        let locale = getLang();
        if (locale.length > 2) {
            locale = locale.substring(0, 2);
        }

        extend("required", required);
        extend("email", email);
        extend("min", min);
        extend("max", max);
        extend("confirmed", confirmed);
        extend("numeric", numeric);
        extend("max_value", max_value);
        extend("min_value", min_value);

        extend("phone", {
            validate(value) {
                const regx = /(^\+(?=84)[0-9]{11}$)|(^0[0-9]{9}$)/;
                return regx.test(value);
            }
        });

        extend("youtubeUrl", {
            validate(value) {
                const regx = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})?/;
                return regx.test(value);
            },
        });

        extend("facebookUrl", {
            validate(value) {
                const regx = /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w-]*)?/;
                return regx.test(value);
            },
        });

        extend("youtubeChannelUrl", {
            validate(value) {
                const regx = /((http|https):\/\/|)(www\.|)youtube\.com\/(channel\/|user\/)[a-zA-Z0-9-]{1,}/;
                return regx.test(value);
            },
        });

        extend("fileExtension", {
            validate(value, formats) {
                console.log(formats)
                if (formats[0] === "*.*") return true;
                const fileName = value[0]?.name;
                return formats.includes("." + getFileExtension(fileName))
            },
        });

        extend("datePickerRequire", {
            validate(value) {
                return !!value.startDate;
            },
        });

        extend("className", {
            validate(value) {
                const regx = /^(1[0-2]|[1-9])([A-Za-z]\S*)$/;
                return regx.test(value);
            }
        });

        localize({
            "en": enVeeValidate,
            "vi": viVeeValidate
        })

        localize(locale)
    }
};

export default veeValidatePlugin;
